import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
// import { Immutable } from 'immutable';
import {ApiConfig} from '../api-config/api-config';

declare const moment: any;

interface State {
    modals: string[];

    user: Object;                   // captures signed in user's idToken, accessToken, etc.
    apiConfig: Object;              // saved info about API urls and AWS config (region, pool id, etc.)
    isLoading: boolean;             // used to display the data loading animation
    life: number;                   // number of seconds after which data
                                    // such as alerts, events and threats in the store should be refreshed
    timestamp: Date;                // timestamp when last call to refresh data was made

    alerts: any[ ];                 // alerts received from the server
    alertsParams: any[ ];           // query parameters used to fetch the alerts

    eventsForAlerts: any[ ];        // events received from the server for alerts
    eventsForAlertsParams: any;     // query parameters used to fetch the events for alerts

    events: any[ ];                 // events received from the server
    eventsParams: any;              // query parameters used to fetch the events

    threats: any[ ];                // threats received from the server
    threatsParams: any;             // query parameters used to fetch the threats

    devices: any[ ];                // devices received from the server
    devicesParams: any[ ];          // query parameters used to fetch the devices

    remoteHosts: any[ ];            // remote hosts received from the server
    remoteHostsParams: any;         // query parameters used to fetch the remote hosts

    timePeriod: string;
    autoRefresh?: number;

    onBodyClick: Observable<MouseEvent>;
}

const initialState: State = {
    modals: [],

    user: {
        customer: null,
        session: null,
        idToken: null,
        accessToken: null
    },
    apiConfig: new ApiConfig(),
    isLoading: false,
    life: 300,
    timestamp: moment(),

    alerts: [],
    alertsParams: [],

    eventsForAlerts: [],
    eventsForAlertsParams: [],

    events: [],
    eventsParams: [],

    threats: [],
    threatsParams: [],

    devices: [],
    devicesParams: [],

    remoteHosts: [],
    remoteHostsParams: [],

    timePeriod: null,
    autoRefresh: null,

    onBodyClick: Observable.fromEvent(document, 'click')
};

const store = new BehaviorSubject<any>(initialState);

@Injectable()
export class Store {

    store = store;

    /*
    changes = store
    // take the observable part of the store
        .asObservable()
        // only broadcast when the state actually changes
        .distinctUntilChanged()
        // log new state to console
        .do(changes => {
            // console.log('changes to state = ', changes)
        });
        */

    constructor() {
        let savedStateString = window.localStorage.getItem('state');
        if (savedStateString) {
            let savedState = JSON.parse(savedStateString);
            this.setState(savedState);
        }
    }

    onChange(prop) {
        const self = this;
        return store.asObservable().pluck(prop).distinctUntilChanged();
    }

    getState(prop?) {
        if (prop == null) {
            return this.store.value;
        } else {
            return this.store.value[prop];
        }
    }

    setState(state: State) {
        // log update to console
        // console.log('setState = ');
        // console.dir(state);
        this.store.next(state);
    }

    purge() {
        this.setState(initialState);
    }

}



// WEBPACK FOOTER //
// /app/src/app/shared/store/store.ts